import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
let SecaService = class SecaService {
    constructor(http) {
        this.http = http;
        this.cargadoSeca = true;
        this.seca = [];
        this.secaRFL = [];
        this.secaRFC = [];
        this.secaRFP = [];
        this.secaRCL = [];
        this.secaRCC = [];
        this.secaRCP = [];
        this.cargarSeca();
    }
    cargarSeca() {
        return new Promise((resolve, reject) => {
            this.http.get('assets/data/dataLineas.json')
                .subscribe((resp) => {
                this.seca = resp;
                console.log(this.seca);
                this.secaRFL = this.seca[9].rutinafacial.limpieza;
                this.secaRFC = this.seca[9].rutinafacial.cuidado;
                this.secaRFP = this.seca[9].rutinafacial.proteccion;
                this.secaRCL = this.seca[9].rutinacorporal.limpieza;
                this.secaRCC = this.seca[9].rutinacorporal.cuidado;
                this.secaRCP = this.seca[9].rutinacorporal.proteccion;
                setTimeout(() => {
                    this.cargadoSeca = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    }
};
SecaService.ctorParameters = () => [
    { type: HttpClient }
];
SecaService = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    })
], SecaService);
export { SecaService };
//# sourceMappingURL=seca.service.js.map